import React from "react";
import { Dialog, Grid, Typography } from "@material-ui/core";
import { DPButton } from "..";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const DPPermissionsDialog = ({ isOpen, onClose }: Props) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Grid
        container
        direction={"column"}
        justify={"center"}
        spacing={2}
        alignItems={"flex-end"}
      >
        <Grid item>
          <Typography variant={"h6"}>
            Sorry, you don't have access to perform that action.
          </Typography>
        </Grid>
        <Grid item>
          <DPButton
            id="permissions-dialog-ok-button"
            align="right"
            color="primary"
            onClick={onClose}
          >
            Ok
          </DPButton>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default DPPermissionsDialog;
